/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CompanyItem } from '../../models/company-item';
import { CompanyUpdateDto } from '../../models/company-update-dto';

export interface CompanyControllerUpdate$Params {
  id: number;
      body: CompanyUpdateDto
}

export function companyControllerUpdate(http: HttpClient, rootUrl: string, params: CompanyControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanyItem;
}>> {
  const rb = new RequestBuilder(rootUrl, companyControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: CompanyItem;
      }>;
    })
  );
}

companyControllerUpdate.PATH = '/company/{id}';
